module.exports = __webpack_public_path__ + "img/Younger.727bbdb0.png";